import React from 'react';

/** 中英文两种左括号都认，翻译文案里用哪种都能断对 */
const BRACKET_PATTERN = /[(（]/;

/**
 * 让菜单文案在**括号处**换行，而不是由容器宽度决定断在哪。
 *
 * 一级菜单容器只有 `w-20`（80px），像「专题分析(试用版)」这种带后缀的文案，
 * 浏览器会按可用宽度在任意字符间回绕，断点随语言和字号变化，看起来像坏掉了。
 *
 * 这里只做一件事：在第一个左括号前插一个 `<br />`，保证括号部分独占一行。
 * 不给两段加 `whitespace-nowrap`——英文 `Analytics (Beta)`、西语 `Análisis (Beta)`
 * 的首段在 80px 内本来就可能放不下，强制不换行会溢出容器。
 *
 * 无括号时原样返回字符串，调用方可以无脑套用。
 */
export function renderLabelWithBracketBreak(text: string): React.ReactNode {
    const index = text.search(BRACKET_PATTERN);
    if (index <= 0) return text;

    const head = text.slice(0, index).trimEnd();
    const tail = text.slice(index);
    return (
        <>
            {head}
            <br />
            {tail}
        </>
    );
}
